import {SC_ApiTimezone} from "./enums/SC_ApiTimezone";

import {DateTime, Info} from "luxon";

export class ApiDateWrapper extends DateTime {
    private isLocal: boolean;
    private isDehydrated: boolean;

    constructor(millis, zone) {
        super({
            ts: millis,
            zone: Info.normalizeZone(zone),
        });
    }

    static fromAPI(arrin: [number, number] | null): ApiDateWrapper | null {
        if (!arrin || arrin.length < 2) {
            return null;
        }

        const [timestamp, timezone] = arrin;

        const scApiTimezone = SC_ApiTimezone.fromAPI(timezone);
        let out = new ApiDateWrapper(timestamp * 1000, scApiTimezone.toString());

        out.isLocal = scApiTimezone.is(SC_ApiTimezone.LOCAL);
        out.isDehydrated = scApiTimezone.is(SC_ApiTimezone.DEHYDRATED);

        return out;
    }

    toAPI(): [number, number] {
        const scApiTimezone = SC_ApiTimezone.fromString(this.zoneName);
        return [this.toSeconds() / 1000, scApiTimezone.value];
    }

    /**
     * Creates a deep copy of this ApiDateWrapper instance
     */
    clone(): ApiDateWrapper {
        const cloned = new ApiDateWrapper(this.toMillis(), this.zoneName);
        cloned.isLocal = this.isLocal;
        cloned.isDehydrated = this.isDehydrated;
        return cloned;
    }

    get truthy(): boolean {
        return this.isValid;
    }

    formatNoteDateLocal() {
        return this.toLocaleString({ month: "short", day: "numeric", hour: "numeric", minute: "numeric", timeZone: this.zoneName })
    }

    formatMD() {
        return this.toLocaleString({ month: "numeric", day: "numeric", timeZone: this.zoneName })
    }

    formatLongCompactDateLocal() {
        return this.toLocaleString({ month: "numeric", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric", timeZone: this.zoneName })
    }

    toMillis(): number {
        return super.toMillis() + (this.isLocal ? (new Date()).getTimezoneOffset() * 60 * 1000 : 0) ;
    }

    rehydrate(tz: SC_ApiTimezone): ApiDateWrapper {
        if (this.isDehydrated)
            return new ApiDateWrapper(this.toMillis(), tz.toString());

        return this;
    }
}
